import { atom } from 'recoil';

import { IUser } from '@/framework/user/types';

export default {
  username: atom<IUser['username'] | undefined>({
    key: 'username',
    default: undefined,
  }),

  country: atom<IUser['country'] | undefined>({
    key: 'country',
    default: undefined,
  }),

  id: atom<IUser['id'] | undefined>({
    key: 'id',
    default: undefined,
  }),

  losses: atom<IUser['losses'] | undefined>({
    key: 'losses',
    default: undefined,
  }),

  score: atom<IUser['score'] | undefined>({
    key: 'score',
    default: undefined,
  }),

  rank: atom<IUser['rank'] | undefined>({
    key: 'rank',
    default: undefined,
  }),

  wins: atom<IUser['wins'] | undefined>({
    key: 'wins',
    default: undefined,
  }),

  total: atom<IUser['total'] | undefined>({
    key: 'total',
    default: undefined,
  }),

  activeGem: atom<IUser['activeGem'] | undefined>({
    key: 'activeGem',
    default: undefined,
  }),

  sparks: atom<IUser['sparks'] | undefined>({
    key: 'sparks',
    default: undefined,
  }),

  xp: atom<IUser['xp'] | undefined>({
    key: 'xp',
    default: undefined,
  }),

  level: atom<IUser['level'] | undefined>({
    key: 'level',
    default: undefined,
  }),

  xpIntoLevel: atom<IUser['xpIntoLevel'] | undefined>({
    key: 'xpIntoLevel',
    default: undefined,
  }),

  xpForNext: atom<IUser['xpForNext'] | undefined>({
    key: 'xpForNext',
    default: undefined,
  }),

  emailVerified: atom<IUser['emailVerified'] | undefined>({
    key: 'emailVerified',
    default: undefined,
  }),

  isGuest: atom<IUser['isGuest'] | undefined>({
    key: 'isGuest',
    default: undefined,
  }),

  hasEmail: atom<IUser['hasEmail'] | undefined>({
    key: 'hasEmail',
    default: undefined,
  }),
};
